import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/users";

// All admin-only. params e.g. { q, page, size }
const getAll = (params = {}) =>
  axios.get(API_URL, { params, headers: authHeader() });

const get = (id) =>
  axios.get(`${API_URL}/${id}`, { headers: authHeader() });

// data: { email?, roles?: string[], password? }
const update = (id, data) =>
  axios.put(`${API_URL}/${id}`, data, { headers: authHeader() });

const remove = (id) =>
  axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

const UserService = { getAll, get, update, remove };

export default UserService;
